import Component from '../colorz/Component';

import device from '../colorz/utils/device';

module.exports = class PlayerYoutube extends Component {
  onInit( el, args) {
    // Initializations
    this.onClick = this.onClick.bind( this );

    this.el = el;
    this.btnPlay = this.el.querySelector('.js-play');
    this.iframe  = this.el.querySelector('.js-player-yt iframe');
    this.iframeSrc = this.iframe.getAttribute('src');
  }

  onReady() {
    this.btnPlay.addEventListener( device.pointerdown, this.onClick );
  }

  onClick() {
    this.btnPlay.classList.add('player--is-active');
    this.el.classList.add('is-active');
    this.iframe.setAttribute('src', this.iframeSrc+'?autoplay=1');
  }
}